<stxt-header *ngIf="!isLander" [ngClass]="{ 'chat-header': isChat }" class="header"></stxt-header>
<div class="app_content flex items-center justify-center">
  <router-outlet></router-outlet>
  <ng-container *ngIf="isLander">
    <stxt-auth-form (closeAuth)="isLander = false" formType="Lander"></stxt-auth-form>
  </ng-container>
</div>
<ng-container *ngIf="showFooter">
  <stxt-footer></stxt-footer>
</ng-container>

<stxt-toast
  *ngIf="currentToast"
  [toast]="currentToast"
  [position]="currentToast?.position || EToastPosition.BOTTOM"
  (closeToast)="onCloseToast()"
  [ngClass]="{
    'fixed-toast-top': (currentToast?.position || EToastPosition.BOTTOM) === EToastPosition.TOP,
    'fixed-toast': (currentToast?.position || EToastPosition.BOTTOM) === EToastPosition.BOTTOM
  }"
></stxt-toast>

<stxt-navigation-bar
  class="mobile-bottom-bar w-full"
  [ngStyle]="{ 'z-index': !isChat ? '999' : '-1' }"
></stxt-navigation-bar>
